import { WarningRegular } from '@fluentui/react-icons'
import type { ConfigIssue } from '@/config/appConfig'
import styles from './ConfigErrorScreen.module.css'

interface ConfigErrorScreenProps {
  issues: ConfigIssue[]
}

/**
 * Shown instead of a blank page when required environment variables are
 * missing. This is a real configuration error state, not a fake bypass.
 */
export function ConfigErrorScreen({ issues }: ConfigErrorScreenProps) {
  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <WarningRegular className={styles.icon} aria-hidden="true" />
        <h1 className={styles.title}>SOC-Copilot nu este configurat</h1>
        <p className={styles.subtitle}>
          Câteva variabile de mediu obligatorii lipsesc. Configurează-le în fișierul{' '}
          <code>.env</code> (pornind de la <code>.env.example</code>) și repornește aplicația.
        </p>
        <ul className={styles.list}>
          {issues.map((issue) => (
            <li key={issue.key} className={styles.item}>
              <code className={styles.key}>{issue.key}</code>
              <span>{issue.message}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
